/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Modal, Button } from "components";

export const ReactivateBrandModal = ({ open, onClose, onOk = () => {}, onCancel = () => {} }) => {
  const handleCancel = () => {
    onCancel();
    onClose();
  };

  const handleOk = () => {
    onOk();
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="medium"
      title={"Reactivate Brand"}
    >
      <div>
        <div>
          Are you sure you want to reactivate this brand?
        </div>
      </div>
      <div className="d-flex mt-4">
        <Button
          size="small"
          buttonTheme="dark"
          width="fit-content"
          className="ml-auto"
          type="button"
          onClick={() => handleCancel()}
        >
          No
        </Button>
        <Button
          size="small"
          buttonTheme="primary"
          width="fit-content"
          className="ml-3"
          type="button"
          onClick={() => handleOk()}
        >
          Yes
        </Button>
      </div>
    </Modal>
  );
};
